<template>
  <v-menu offset-y>
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" class="d-flex align-center ml-2">
        <v-divider vertical style="background: #484848" />
        <v-icon class="mr-n2 ml-3px">mdi-menu-down</v-icon>
      </div>
    </template>

    <div class="bg-white pt-1 w-280">
      <span class="font-12 text-gray-1100 px-2">
        <v-icon :size="18">mdi-menu</v-icon>
        Lista de opções
      </span>

      <v-divider />

      <FracionarPedidos @atualizarFracionamento="atualizarPedidosFracionados">
        <template #ativador="{ callback }">
          <v-list-item @click.stop="callback">
            <v-list-item-title class="d-flex align-center">
              Fracionamento de Pedido
            </v-list-item-title>
          </v-list-item>
        </template>
      </FracionarPedidos>
    </div>
  </v-menu>
</template>

<script>
import FracionarPedidos from "@/components/drp/separacaoDeMercadorias/Carrinho/ListaOpcoes/FracionarPedidos.vue";
import SeparacaoProdutosPorLista from "@/components/drp/ListaSeparacao/SeparacaoProdutos/Index.vue";

export default {
  name: "OutrasOpcoes",
  components: {SeparacaoProdutosPorLista, FracionarPedidos},
  methods: {
    atualizarPedidosFracionados() {
      this.$emit('atualizarFracionamento', true);
    }
  }
}
</script>
